import { Component } from "react";
import { Link } from "react-router-dom";

const title = "";
const desc = "PERFECT LINES. ZERO MISTAKES. FULL SEND.";
const btnText = "Watch Now";


class BannerSection extends Component {
    render() { 
        return (
            <section className="banner-section" style={{ backgroundImage: "url(/assets/images/banner/02.jpg)" }}>
                <div className="container">
                    <div className="">
                        <div className="banner-content text-center">
                            <h4 className="fw-normal theme-color mb-4">{title}</h4>
                            <img src="assets/images/banner/.png" alt="" className="mb-4" />
                            <p className="text-anim-fade-soft animate">{desc}</p>
                            
                        </div>
                        
                        <div className="banner-thumb d-flex flex-wrap justify-content-center justify-content-between align-items-center align-items-lg-end">
                            <div className="banner-thumb-img ml-xl-50-none">
                                <Link to="/team-single"><img src="assets/images/banner/.png" alt="" /></Link>
                            </div>
                            <div className="banner-thumb-vs">
                                <img src="assets/images/banner/" alt="" />
                            </div>
                            <div className="banner-thumb-img mr-xl-50-none">
                                <Link to="/team-single"><img src="assets/images/banner/.png" alt="" /></Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}
 
export default BannerSection;